// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer___2MlqU","container":"footer__container___2ZRQ8","actions":"footer__actions___1F4Ip","navigation":"footer__navigation___2lYw6","nav":"footer__nav___6gy9K","contact":"footer__contact___3GhCD","navMainItem":"footer__navMainItem___1xc1k","meta":"footer__meta___3eqqe","copyright":"footer__copyright___2ZXq6","metaNavigation":"footer__metaNavigation___37k-Z","fadein":"footer__fadein___3NxOL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/footer/footer.scss
// module id = 361
// module chunks = 0